import React from "react";
import classNames from "classnames";
import "./styles.scss";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  large?: boolean;
  navigation?: boolean;
  previous?: boolean;
  next?: boolean;
}

function Button({
  large = false,
  navigation = false,
  previous,
  next,
  disabled,
  className,
  children,
  ...rest
}: ButtonProps) {
  const fillColor = disabled
    ? "var(--fl-color-disabled)"
    : navigation
    ? "var(--fl-color-primary)"
    : "var(--color-blue)";

  return (
    <button
      className={classNames("tg_button", className)}
      disabled={disabled}
      {...rest}
    >
      {previous && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="12"
          viewBox="0 0 13 12"
          fill="none"
        >
          <path
            d="M2.44629 7.4834H2.44531L0.962891 6.00098H0.963867L0.962891 6L2.44531 4.51758L2.44629 4.51855L6.15234 0.811523L7.63477 2.29395L4.99023 4.93848H12.0371V7.03516H4.96387L7.63477 9.70605L6.15234 11.1885L2.44629 7.4834Z"
            fill={fillColor}
          />
        </svg>
      )}
      {children}
      {next && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="12"
          viewBox="0 0 13 12"
          fill="none"
        >
          <path
            d="M10.5536 4.5166H10.5546L12.037 5.99902H12.036L12.037 6L10.5546 7.48242L10.5536 7.48145L6.84753 11.1885L5.36511 9.70605L8.00964 7.06152H0.962769V4.96484H8.03699L5.36609 2.29395L6.84851 0.811523L10.5536 4.5166Z"
            fill={fillColor}
          />
        </svg>
      )}
    </button>
  );
}

export default Button;
